module.exports = __webpack_public_path__ + "static/burp-16170277f2bf2221696a8408cba0baeb.png";